module.exports = __webpack_public_path__ + "static/media/DSC_6729_HDR-Edit.f4e63814.jpg";